/**
 * Opens a request detail overlay (via whichever RequestDetails-like component
 * is active on the page) from a same-origin link containing a
 * `request_id`/`request-id` query param, instead of letting the browser
 * navigate there and reload the page.
 *
 * Used by the notification bell dropdown and by any other in-page link that
 * points at a request (e.g. dashboard notification/activity previews) so they
 * all share one "open in place" behaviour.
 *
 * @param {string} link
 * @returns {boolean} true if a component handled it (caller should not navigate).
 */
export function openRequestDetailFromLink(link) {
    if (!link) return false;

    let parsed;
    try {
        parsed = new URL(link, window.location.origin);
    } catch (e) {
        return false;
    }

    if (parsed.origin !== window.location.origin) {
        return false;
    }

    const requestIdRaw = (parsed.searchParams.get('request-id') || parsed.searchParams.get('request_id') || '').trim();
    if (!requestIdRaw) {
        return false;
    }

    const requestId = parseInt(requestIdRaw, 10);
    if (!Number.isInteger(requestId) || requestId <= 0) {
        return false;
    }

    const app = window.DocuswiftPortal;
    if (!app || typeof app.getComponent !== 'function') {
        return false;
    }

    const candidates = ['requestDetails', 'cmRequestDetails', 'companyAdminRequestDetails']
        .map((name) => app.getComponent(name))
        .filter((component) => component && typeof component.show === 'function');
    const targetComponent = candidates.find((component) => component.details && component.overlay) || candidates[0];
    if (!targetComponent) {
        return false;
    }

    targetComponent.show(String(requestId));
    if (typeof targetComponent.initRequestUploadModal === 'function') {
        targetComponent.initRequestUploadModal();
    }
    if (typeof targetComponent.initConfirmFacilityModal === 'function') {
        targetComponent.initConfirmFacilityModal();
    }

    return true;
}
